export type OperationStatus =
  | 'fullyRead'
  | 'partialReadArea1'
  | 'partialReadArea2'
  | 'switchAcceptedNoReads'
  | 'switchAcceptedWithArea1'
  | 'failed'
  | 'irregular'

export function readTimesOf(status: OperationStatus): number {
  switch (status) {
    case 'fullyRead':
      return 2
    case 'partialReadArea1':
    case 'partialReadArea2':
    case 'switchAcceptedWithArea1':
      return 1
    case 'switchAcceptedNoReads':
    case 'failed':
      return 0
    case 'irregular':
      return 99
  }
}

export function isCompleted(status: OperationStatus): boolean {
  switch (status) {
    case 'fullyRead':
    case 'switchAcceptedNoReads':
    case 'switchAcceptedWithArea1':
      return true
    case 'partialReadArea1':
    case 'partialReadArea2':
    case 'failed':
    case 'irregular':
      return false
  }
}

export function isPartialReadOnly(status: OperationStatus): boolean {
  switch (status) {
    case 'partialReadArea1':
    case 'partialReadArea2':
      return true
    case 'fullyRead':
    case 'switchAcceptedNoReads':
    case 'switchAcceptedWithArea1':
    case 'failed':
    case 'irregular':
      return false
  }
}
